<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Definir período do mês '"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

                <v-layout row wrap>
                  <v-flex xs11 sm5>
                    <v-text-field
                      label='Início (Dia do mês)'
                      v-model="periodoFrequencia.diaInicial"
                      type="number"
                      required
                      :rules="diaDoMesRules"
                    ></v-text-field>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs11 sm5>
                    <v-text-field
                      label='Fim (Dia do mês)'
                      v-model="periodoFrequencia.diaFinal"
                      type="number"
                      required
                      :rules="diaDoMesRules"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

              </v-container>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="cancelar">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="definirPeriodoFrequencia()">Salvar</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import DataMenu from '@/components/c-date-menu'
  import bolsas from '@/utils/bolsas'
  import { mapActions } from 'vuex'

  export default {
    data: () => ({
      periodoFrequencia: {},
      diaDoMesRules: [
        (input) => !!input || 'Este campo é obrigatório',
        (input) => !isNaN(parseFloat(input)) && input >= 1 && input <= 31 || 'Dia do mês inválido'
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      cancelar: function () {
        this.$router.push({name: 'ProjetosAguardandoAprovacao'})
      },
      definirPeriodoFrequencia: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando período de frequência.' })
        bolsas.postPeriodoFrequencia(this.periodoFrequencia)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: 'Período de atribuição da frequência alterado com sucesso!'})
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando período de frequência.' })
        })
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando período de frequência.' })
      bolsas.getPeriodoFrequencia()
      .then(response => {
        this.periodoFrequencia = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando período de frequência.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-date-menu': DataMenu
    }
  }
</script>



// WEBPACK FOOTER //
// definir-periodo-frequencia.vue?6fc4ed59